module.exports = __webpack_public_path__ + "static/img/teamHonorBg4.75fa2921.png";